export const COLLAPSIBLES = {
  MENU_ITEM_CATEGORIES: {
    NAME: 'menuiItemCategories',
    MULTIPLE: true,
  },
  RECIPE_CATEGORIES: {
    NAME: 'recipeCategories',
    MULTIPLE: true,
  },
  COST_INTERFACE: {
    NAME: 'costInterface',
    MULTIPLE: false,
  },
  BACKGROUND_CATEGORIES: {
    NAME: 'backgroundCategories',
    MULTIPLE: true,
  },
  CANVAS_PAGE_OPTIONS: {
    NAME: 'canvasPageOptions',
    MULTIPLE: false,
  },
  CANVAS_PAGE_OPTIONS_BACKGROUND: {
    NAME: 'optionsBackground',
    MULTIPLE: true,
  },
  CANVAS_PAGE_OPTIONS_CONTENT: {
    NAME: 'optionsContent',
    MULTIPLE: true,
  },
  INGREDIENT_RECIPES_AUTO_SUGGEST_OPTIONS:{
    NAME: 'ingredientRecipesAutoSuggestOptions',
    MULTIPLE: false,
  },
  RECIPE_SEARCH_INGREDIENTS: {
    NAME: 'recipeSearchIngredients',
    MULTIPLE: true,
  },
  WHAT_IF_CALC_TRY_SCEN: {
    NAME: 'whatIfCalculatorTryScenarios',
    MULTIPLE: true,
  },
};
